import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const t = localStorage.getItem("kra_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const api = {
  login: (email, password) => client.post(`/auth/login`, { email, password }).then((r) => r.data),
  me: () => client.get(`/auth/me`).then((r) => r.data),
  logout: () => client.post(`/auth/logout`).then((r) => r.data),
  dashboard: (month, year) => client.get(`/dashboard`, { params: { month, year } }).then((r) => r.data),
  performance: (month, year) => client.get(`/performance`, { params: { month, year } }).then((r) => r.data),
  employees: (params) => client.get(`/employees`, { params }).then((r) => r.data),
  brands: () => client.get(`/brands`).then((r) => r.data),
  growth: (params) => client.get(`/growth`, { params }).then((r) => r.data),
  createGrowth: (body) => client.post(`/growth`, body).then((r) => r.data),
  updateGrowth: (id, body) => client.put(`/growth/${id}`, body).then((r) => r.data),
  deleteGrowth: (id) => client.delete(`/growth/${id}`).then((r) => r.data),
  shoots: (params) => client.get(`/shoots`, { params }).then((r) => r.data),
  createShoot: (body) => client.post(`/shoots`, body).then((r) => r.data),
  updateShoot: (id, body) => client.put(`/shoots/${id}`, body).then((r) => r.data),
  deleteShoot: (id) => client.delete(`/shoots/${id}`).then((r) => r.data),
  users: () => client.get(`/users`).then((r) => r.data),
  resetPassword: (id, new_password) => client.post(`/users/${id}/reset-password`, { new_password }).then((r) => r.data),
  changePassword: (current_password, new_password) => client.post(`/auth/change-password`, { current_password, new_password }).then((r) => r.data),
  employee: (id) => client.get(`/employees/${id}`).then((r) => r.data),
  createEmployee: (body) => client.post(`/employees`, body).then((r) => r.data),
  updateEmployee: (id, body) => client.put(`/employees/${id}`, body).then((r) => r.data),
  deleteEmployee: (id) => client.delete(`/employees/${id}`).then((r) => r.data),
  contentTasks: (params) => client.get(`/content-tasks`, { params }).then((r) => r.data),
  createContentTask: (body) => client.post(`/content-tasks`, body).then((r) => r.data),
  updateContentTask: (id, body) => client.put(`/content-tasks/${id}`, body).then((r) => r.data),
  deleteContentTask: (id) => client.delete(`/content-tasks/${id}`).then((r) => r.data),
  devTasks: (params) => client.get(`/dev-tasks`, { params }).then((r) => r.data),
  createDevTask: (body) => client.post(`/dev-tasks`, body).then((r) => r.data),
  updateDevTask: (id, body) => client.put(`/dev-tasks/${id}`, body).then((r) => r.data),
  deleteDevTask: (id) => client.delete(`/dev-tasks/${id}`).then((r) => r.data),
  monthlyReview: (employee_id, month, year) => client.get(`/reviews/monthly`, { params: { employee_id, month, year } }).then((r) => r.data),
  saveMonthlyReview: (body) => client.post(`/reviews/monthly`, body).then((r) => r.data),
  lockReview: (id, locked) => client.post(`/reviews/monthly/${id}/lock`, { locked }).then((r) => r.data),
  monthlyReviewList: (month, year) => client.get(`/reviews/monthly/list`, { params: { month, year } }).then((r) => r.data),
  quarterly: (employee_id, quarter, year) => client.get(`/reviews/quarterly`, { params: { employee_id, quarter, year } }).then((r) => r.data),
  yearly: (employee_id, year) => client.get(`/reviews/yearly`, { params: { employee_id, year } }).then((r) => r.data),
  incrementOverride: (body) => client.post(`/reviews/increment-override`, body).then((r) => r.data),
  notifications: () => client.get(`/notifications`).then((r) => r.data),
  markRead: (id) => client.post(`/notifications/${id}/read`).then((r) => r.data),
  markAllRead: () => client.post(`/notifications/read-all`).then((r) => r.data),
  settings: () => client.get(`/settings`).then((r) => r.data),
  updateSettings: (body) => client.put(`/settings`, body).then((r) => r.data),
  auditLog: () => client.get(`/audit-log`).then((r) => r.data),
};

export function downloadExport(module, format, params = {}) {
  const qs = new URLSearchParams({ format, ...params }).toString();
  const a = document.createElement("a");
  a.href = `${API}/export/${module}?${qs}`;
  a.download = "";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
